import React from 'react';
import '../CSS/Home.css'
import Particlec from '../Particle/Particlec'
import Typed from 'react-typed';
const Home = () => {
    return (
      <>
       <Particlec/>

       <div className="backHome">
       <div className="containr" >
         <div className='row'>
            <div className="col-10 mx-auto">
               <div className="col-8 me-auto">
                  <h1>Hey,I am Suprodip</h1>
                  <Typed
                     className="typedText"
                     strings={["Web Developer","Coder","CP Enthusiast","UI/Ux Enthusiast"]}
                     typeSpeed={40}
                     backSpeed={60}
                     loop
                  />
               </div> 
            </div>
         </div>
       </div>
      </div> 
      </>      
    )
}

export default Home;

